import styled from 'styled-components';

import { ADSLoading, ADSPage } from '@aphrodite/common-ui';

// Styled Components
const StyledContainer = styled(ADSPage)`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 100vw;
`;

export default function PageLoading(): React.ReactElement {
  return (
    <StyledContainer>
      <ADSLoading size="l" />
    </StyledContainer>
  );
}
